import { createProgressActions, createActionCreators } from '../utils';

const locate = createActionCreators(createProgressActions('LOCATE'));

const actions = {
 locate: locate.names,
};

export default actions;
export { locate };



// WEBPACK FOOTER //
// ./src/app/models/Location/actions.ts